<div class="form-flex editable-content date-range-picker">
	<div class="form-flex-row dual-row">
		<span class="new-item-label">
			<label for="start-date-input">{{(labelPre + '.startDate') | translate}}:</label>
		</span>
		<div class="form-flex-input">
			<input type="text" #startDate="bsDatepicker" bsDatepicker triggers="" [outsideClick]="true" [maxDate]="item.end" [bsConfig]="dateConfig" id="start-date-input" [placeholder]="((labelPre + '.startDate') | translate)" [ngModel]="item.start" (ngModelChange)="item.start = $event; onChange(item);" tabindex="0">
		</div>
		<div class="form-flex-label">
			<span class="calendar-button" id="start-date-btn" type="button" (click)="startDate.toggle()" attr.aria-label="{{'calendar.btn.start.date.aria.label' | translate}}" attr.tooltip="{{'calendar.btn.start.date.aria.label' | translate}}" role="button">
				<span class="sr-only">{{'calendar.btn.start.date.aria.label' | translate}}</span>
				<i class="fa fa-calendar input-dates" attr.aria-hidden="true"></i>
			</span>
		</div>
		<span class="new-item-label">
			<label for="end-date-input">{{(labelPre + '.endDate') | translate}}:</label>
		</span>
		<div class="form-flex-input">
			<input type="text" #endDate="bsDatepicker" bsDatepicker triggers="" [outsideClick]="true" [minDate]="item.start" [bsConfig]="dateConfig" id="end-date-input" [placeholder]="((labelPre + '.endDate') | translate)" [ngModel]="item.end" (ngModelChange)="item.end = $event; onChange(item);" tabindex="0">
		</div>
		<div class="form-flex-label">
			<span class="calendar-button" id="end-date-btn" type="button" (click)="endDate.toggle()" attr.aria-label="{{'calendar.btn.end.date.aria.label' | translate}}" attr.tooltip="{{'calendar.btn.end.date.aria.label' | translate}}" role="button">
				<span class="sr-only">{{'calendar.btn.end.date.aria.label' | translate}}</span>
				<i class="fa fa-calendar input-dates" attr.aria-hidden="true"></i>
			</span>
		</div>
		<div class="dates-range-display-cb" *ngIf="item.start || item.end"> <!--ctrl.visibleDatesLabel &&-->
			<span class="normal-cb">
				<input id="visible-in-dates-cb" type="checkbox" [ngModel]="item.isVisibleBetweenDates" (ngModelChange)="item.isVisibleBetweenDates = $event; onChange(item);" [checked]="item.isVisibleBetweenDates"
					rlStopPropagation>
				<label for="visible-in-dates-cb">{{'ctrl.visibleDatesLabel' | translate}}</label>
			</span>
		</div>
	</div>
</div>
<div class="form-dates" *ngIf="item.start && item.end && item.start > item.end">
	<!-- <div class="error-message">{{'list.action.addCourse.startDateBeforeEnd'| translate}}</div> -->
	<!-- <div ng-show="ctrl.invalidDates" class="error-message">{{'list.action.addCourse.invalidDates' | translate}}</div> -->
</div>